import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ApiKeysResponse, CreateApiKeyRequest } from './api-keys.model';

@Injectable({ providedIn: 'root' })
export class ApiKeysService {
  private readonly apiUrl = environment.apiUrl + '/api/api-keys/';

  private readonly http = inject(HttpClient);

  getAllApiKeys(): Observable<ApiKeysResponse> {
    return this.http.get<ApiKeysResponse>(this.apiUrl);
  }

  createApiKey(payload: CreateApiKeyRequest): Observable<ApiKeysResponse> {
    return this.http.post<ApiKeysResponse>(this.apiUrl, payload);
  }

  deleteApiKey(id: number): Observable<ApiKeysResponse> {
    return this.http.delete<ApiKeysResponse>(this.apiUrl + id);
  }

  updateApiKey(id: number, payload: CreateApiKeyRequest): Observable<ApiKeysResponse> {
    return this.http.put<ApiKeysResponse>(this.apiUrl + id, payload);
  }
}
